import * as Enums from "./enums";

export const removeMask = (val) => {
  return String(val).replace(/\D+/g, "");
};

export const dateToBack = (val) => {
  return String(val).split("/").reverse().join("-");
};
export const dateToValid = (val) => {
  return String(val).split(/\D+/g).reverse().join(", ");
};

export const dateToFront = (val) => {
  return String(val).split("-").reverse().join("/");
};

export const formatCurrencyFront = (value) => {
  if (!value) return value;
  const patrimony = (value / 100).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
  return patrimony;
};

export const normalizeText = (value) => {
  return value?.normalize("NFD").replace(/([\u0300-\u036f]|[^a-zA-Z\s])/g, "");
};

export const normalizeTextWithNumber = (value) => {
  return value?.normalize("NFD").replace(/([\u0300-\u036f]|[^a-zA-Z0-9\s])/g, "");
};

export const formatCurrency = (value) => {
  if (!value) return value;
  value = String(value);
  const newValue = value.replace(/[R$]/g, "");
  newValue.replace(/[^0-9]/g, "");

  return newValue;
};

export const formatDataToBack = (data) => {
  let newData = {};
  if (data.email) newData["email"] = String(data.email);
  if (data.taxId) newData["taxId"] = String(removeMask(data.taxId));
  if (data.legalName)
    newData["legalName"] = String(data.legalName).toUpperCase();
  if (data.tradeName)
    newData["tradeName"] = String(data.tradeName).toUpperCase();
  if (data.openingDate)
    newData["openingDate"] = String(dateToBack(data.openingDate));
  if (data.mobile1) newData["mobile1"] = String(removeMask(data.mobile1));
  if (data.zipCode) newData["zipCode"] = String(removeMask(data.zipCode));
  if (data.financialEquity)
    newData["financialEquity"] = String(data.financialEquity).replace(
      /[^0-9]/g,
      ""
    );
  if (data.financialProfit)
    newData["financialProfit"] = String(data.financialProfit).replace(
      /[^0-9]/g,
      ""
    );
  // if (data.patrimony) newData['patrimony'] = String(data.patrimony).replace(/\D+/g, '')
  // if (data.salary) newData['salary'] = String(data.salary).replace(/\D+/g, '')
  // if (data.pep) newData['pep'] = data.pep || false
  // if (data.type === 'personal') {
  //   if (data.motherName) newData['motherName'] = String(data.motherName).toUpperCase()
  //   if (data.maritalStatus) newData['maritalStatus'] = String(data.maritalStatus)
  //   if (data.birthDate) newData['birthDate'] = String(dateToBack(data.birthDate))
  // } else {
  //   newData['name'] = String(data.legalName).toUpperCase()
  //   if (data.type) newData['type'] = String(data.type || 'corporate')
  //   if (data.establishmentFormat) newData['establishmentFormat'] = String(Enums.typeEstablishment[data.establishmentFormat])
  // }
  return { ...data, ...newData };
};

export const formatDataToFront = (data) => {
  let newData = {};
  if (data.email) newData["email"] = String(data.email);
  if (data.type) newData["type"] = String(data.type || "personal");
  if (data.taxId) newData["taxId"] = String(removeMask(data.taxId));
  if (data.financialEquity)
    newData["financialEquity"] = String(formatCurrency(data.financialEquity));
  if (data.financialProfit)
    newData["financialProfit"] = String(formatCurrency(data.financialProfit));
  if (data.pep) newData["pep"] = data.pep || false;
  if (data.type === "personal") {
    if (data.motherName)
      newData["motherName"] = String(data.motherName).toUpperCase();
    if (data.maritalStatus)
      newData["maritalStatus"] = String(
        Enums.maritalStatus[data.maritalStatus]
      );
    if (data.birthDate)
      newData["birthDate"] = String(dateToFront(data.birthDate));
    if (data.patrimony)
      newData["patrimony"] = String(formatCurrencyFront(data.patrimony));
    if (data.issuingDate)
      newData["issuingDate"] = String(dateToFront(data.issuingDate));
    if (data.salary)
      newData["salary"] = String(formatCurrencyFront(data.salary));
  } else {
    newData["name"] = String(data.legalName).toUpperCase();
    if (data.type) newData["type"] = String(data.type || "corporate");
    if (data.establishmentFormat)
      newData["establishmentFormat"] = String(
        Enums.typeEstablishment[data.establishmentFormat]
      );
    if (data.legalName)
      newData["legalName"] = String(data.legalName).toUpperCase();
    if (data.tradeName)
      newData["tradeName"] = String(data.tradeName).toUpperCase();
    if (data.issuingDate)
      newData["issuingDate"] = String(dateToFront(data.issuingDate));
  }
  return { ...data, ...newData };
};
